import { apiAMS, getDataSimple } from "app/helpers/apiHelper";

const API_REGISTRATION = "/public/registration";
const API_PUBLIC_REGISTRATION_COUNTRIES = "/public/registration/country";

/**
 * POST Registration form
 */
export const createAccount = (params: any): any => {
  return apiAMS.post(API_REGISTRATION, params);
};

/**
 * fetch heardAboutUs options
 */
export const fetchHeardAboutUsOptions = (): any => {
  const url = "/heardAboutUs";
  return getDataSimple(url);
};

/**
 * fetch list countries for the direct registration client from AMS
 */
export const fetchCountriesForPublicRegistration = (): any => {
  const url = API_PUBLIC_REGISTRATION_COUNTRIES;
  const params = { lang: "en" }; // BET-15946 - As discussed: AMS wasn't translating all so for now only get in English, for all locales
  return apiAMS
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * POST validate user name
 */
export const validateUsername = (username: string) => {
  return apiAMS.post(`${API_REGISTRATION}/validateUsername`, username);
};
/**
 * POST validate email
 */
export const validateEmail = (email: string) => {
  return apiAMS.post(`${API_REGISTRATION}/validateEmail`, email);
};
/**
 * POST validate password
 */
export const validatePassword = (password: string) => {
  return apiAMS.post(`${API_REGISTRATION}/validatePassword`, password);
};
/**
 * POST validate personal details
 */
export const validatePersonalDetails = (params: {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  gender: string;
  country: string;
  state: string;
  addressLine1: string;
  addressLine2?: string | null;
  city?: string;
  postCode: string;
  contactNumber: string;
}) => {
  return apiAMS.post(`${API_REGISTRATION}/validatePersonalDetails`, params);
};
/**
 * POST validate account settings
 */
export const validateAccountSettings = (params: {
  currency: number;
  heardAboutUs: string;
  promoCode: string;
  consentToMarketing: boolean;
  acceptedTCs: boolean;
}) => {
  return apiAMS.post(`${API_REGISTRATION}/validateAccountSettings`, params);
};
